import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { GlobalService } from '../global/global.service';
import { PermissionsService } from '../permissions/permissions.service';

@Injectable()
export class SkillsGuardService {
    constructor(
        private router: Router,
        private permissionsService: PermissionsService,
    ) {}

    public canActivate(): boolean | UrlTree {
        return (
            this.permissionsService.checkPermission({
                name: 'management_skills',
            }) || this.router.parseUrl('/error/403')
        );
    }
}
